import { ChangeEventHandler, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { FormInput, VerticalForm } from '../components/custom/components'
import AuthLayout from '../components/custom/pages/AuthLayout'
import { ToastTypes, useToast } from '../components/toast/ToastProvider'
import { errorHandler } from '../config/api'
import { LoginDataType, loginUser } from '../redux/actions/authUserActions'
import { AppDispatch } from '../redux/store'
import '../styles/styles.css'

const Login = () => {
    const toast = useToast()
    const dispatch = useDispatch<AppDispatch>()

    const [loading, setLoading] = useState<boolean>(false)
    const [mounted, setMounted] = useState<boolean>(false)

    const [username, setUsername] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [passwordError, setPasswordError] = useState<string>('')
    const [usernameError, setUsernameError] = useState<string>('')

    const handleUsername: ChangeEventHandler<HTMLInputElement> = (event) => {
        setUsernameError('')
        setUsername(event.target.value)
        if (event.target.value === '') {
            setPassword('')
        }
    }

    const handlePassword: ChangeEventHandler<HTMLInputElement> = (event) => {
        setPasswordError('')
        setPassword(event.target.value)
    }

    const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (event) => {
        if (event.key === ' ') {
            event.preventDefault()
        }

    }

    let error = false
    const loginInsights = (data: LoginDataType) => {
        if (data.userId === '' && data.password === '') {
            setUsernameError('Username required')
            setPasswordError('Password required')
            error = true
        } else if (data.userId === '') {
            setUsernameError('Username required')
            error = true
        } else if (data.password === '') {
            setPasswordError('Password required')
            error = true
        }
        else if (data.userId.length > 10) {
            setUsernameError('Username length should not be greater than 10')
            error = true
        } else if (data.password.length > 10) {
            setPasswordError('Password length should not be greater than 10')
            error = true
        } else if (data.userId.length < 5) {
            setUsernameError('Username length should be greater than 5')
            error = true
        } else if (data.password.length < 5) {
            setPasswordError('Password length should be greater than 5')
            error = true
        }
    }

    const handleLogin = (event: any) => {
        event.preventDefault()
        const data: LoginDataType = {
            userId: username,
            password: password
        }

        // loginInsights(data)

        if (!error) {
            setLoading(true)
            dispatch(loginUser(data)).then(text => {
                toast('Logged in')
            }).catch(e => {
                toast(errorHandler(e), ToastTypes.ERROR)
            }).finally(() => {
                if (mounted) {
                    setLoading(false)
                }
            })
        }
    }

    useEffect(() => {
        setMounted(true)
        return () => setMounted(false)
    }, [])

    return <AuthLayout helpText={'Enter username and password to login.'}>
        <VerticalForm onSubmit={handleLogin}>
            <FormInput
                label={'Username'}
                type='text'
                name='username'
                value={username}
                placeholder='Enter your Username'
                onChange={handleUsername}
                errorText={usernameError}
                containerClass='mb-3'
                className={'custom-input'}
                labelClassName='text-white'
            // onKeyDown={handleKeyDown}
            />
            <FormInput
                label={'Password'}
                type='password'
                name='password'
                value={password}
                placeholder='Enter your password'
                onChange={handlePassword}
                errorText={passwordError}
                containerClass='mb-3'
                className={'custom-input'}
                disabled={username === ''}
                labelClassName='text-white'
            // onKeyDown={handleKeyDown}
            />
            <div className='text-center d-grid'>
                {loading
                    ? <Button variant='primary' type='button' disabled className='btn-lg p-2'>
                        Log In
                    </Button>
                    : <Button variant='primary' type='submit' className='btn-lg p-2'>
                        Log In
                    </Button>}
            </div>
            <div className="mt-2">
                <Link to="#" className="text-primary-50">
                    Forgot your password?
                </Link>
            </div>
        </VerticalForm>
    </AuthLayout>
}

export default Login
